

var swiper = new Swiper('.hero-slider .swiper-container', {
  loop: true,
  pagination: {
    el: '.hero-slider .swiper-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.hero-slider .swiper-button-next',
    prevEl: '.hero-slider .swiper-button-prev',
  },
  watchOverflow: false
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    new Swiper(".category-swiper", {
      slidesPerView: 3,
      spaceBetween: 15,
      loop: true, // ✅ continuous loop
      autoplay: {
        delay: 2000, // ⏱ slide every 2 seconds
        disableOnInteraction: false // ✅ keep autoplay after user swipe
      },
      breakpoints: {
        0: { slidesPerView: 3, spaceBetween: 10 },
        480: { slidesPerView: 3, spaceBetween: 15 }
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  new Swiper(".product-swiper", {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      disabledClass: "never-disable" // fake class
    },
    pagination: {
    el: '.swiper-pagination',
    clickable: true,
    },
    watchOverflow: false, 
    breakpoints: {
      320: { slidesPerView: 1.2, spaceBetween: 15 },
      480: { slidesPerView: 2, spaceBetween: 15 },
      768: { slidesPerView: 3, spaceBetween: 20 },
      1024: { slidesPerView: 4, spaceBetween: 20 }
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  new Swiper(".image-swiper", {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: ".image-swiper .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1200: { slidesPerView: 2 }
    }
  });
});

document.addEventListener("DOMContentLoaded", function(){
  const tabs = document.querySelectorAll(".faq-tabs .tab-btn");
  const tabContents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tabContents.forEach(c => c.classList.remove("active"));
      tab.classList.add("active");
      document.getElementById(tab.dataset.tab).classList.add("active");
    });
  });

  // FAQ Left Active toggle
  document.querySelectorAll(".faq-left").forEach(group => {
    const items = group.querySelectorAll(".faq-item");
    items.forEach(btn => {
      btn.addEventListener("click", () => {
        items.forEach(i => i.classList.remove("active"));
        btn.classList.add("active");
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".counter");
  const speed = 200; // lower = faster

  const startCounting = () => {
    counters.forEach(counter => {
      const updateCount = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText;
        const increment = target / speed;

        if (count < target) {
          counter.innerText = Math.ceil(count + increment);
          requestAnimationFrame(updateCount);
        } else {
          counter.innerText = target.toLocaleString() + "+";
        }
      };
      updateCount();
    });
  };

  // Start counting when visible
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        startCounting();
        observer.disconnect();
      }
    });
  });
  const statsEl = document.querySelector(".stats-section"); if (statsEl) { observer.observe(statsEl); }
  });
